import axios from "axios";

export async function getLocation(input, state = null, country = null) {
  const params = { input };
  
  // Add state and country parameters if provided
  if (state) {
    params.state = state;
  }
  if (country) {
    params.country = country;
  }
  
  try {
    const res = await axios.get("/location", { params });
    return res.data;
  } catch (error) {
    return [];
  }
}
